const colors = {
  tprimary: "#f7d18d",
  tsecondary: "#1e1e1e",
  ttertiary: "#ba8023",
};

export default colors;
